export type CompactPanelId = 'legend' | 'sidebar'

export const COMPACT_PANEL_OPEN_EVENT = 'roguelike:compact-panel-open'

export function announceCompactPanelOpen(panel: CompactPanelId): void {
  window.dispatchEvent(new CustomEvent<CompactPanelId>(COMPACT_PANEL_OPEN_EVENT, { detail: panel }))
}

export function listenForOtherCompactPanel(
  panel: CompactPanelId,
  close: () => void,
): () => void {
  const listener = (event: Event) => {
    if ((event as CustomEvent<CompactPanelId>).detail !== panel) close()
  }
  window.addEventListener(COMPACT_PANEL_OPEN_EVENT, listener)
  return () => window.removeEventListener(COMPACT_PANEL_OPEN_EVENT, listener)
}
